module.exports = new __parcel__URL__("wish-you-were-here.15efede5.jpg").toString();